export interface ExperienceInsightView {
	viewType: string;
	displayName: string;
}

export interface ExperienceSignalsResponse {
	views: ExperienceInsightView[];
	viewType?: string | null;
	reportDate?: string | null;
	insightHtml?: string | null;
	displayName?: string | null;
	clientId?: string | null;
}

export interface ExperienceFeedbackDetail {
	feedbackId?: string | null;
	sourceReferenceId?: string | null;
	sourcePlatform?: string | null;
	channelId?: string | null;
	channelName?: string | null;
	feedbackDate?: string | null;
	feedbackDateDisplay?: string | null;
	customerName?: string | null;
	summary?: string | null;
	body?: string | null;
	productName?: string | null;
	categoryName?: string | null;
	sentimentCategory?: string | null;
	churnRisk?: number | null;
	churnRiskScore10?: number | null;
	rootCause?: string | null;
}

export const mapExperienceSignalsResponse = (payload: any): ExperienceSignalsResponse => {
	const views = Array.isArray(payload?.views)
		? payload.views
				.map((view: any) => ({
					viewType: view?.view_type ?? view?.viewType ?? '',
					displayName:
						view?.display_name ?? view?.displayName ?? view?.view_type ?? view?.viewType ?? '',
				}))
				.filter((view: ExperienceInsightView) => Boolean(view.viewType))
		: [];

	return {
		views,
		viewType: payload?.view_type ?? payload?.viewType ?? null,
		reportDate: payload?.report_date ?? payload?.reportDate ?? null,
		insightHtml: payload?.insight_html ?? payload?.insightHtml ?? null,
		displayName: payload?.display_name ?? payload?.displayName ?? null,
		clientId: payload?.client_id ?? payload?.clientId ?? null,
	};
};

export const mapExperienceFeedbackDetail = (payload: any): ExperienceFeedbackDetail => ({
	feedbackId: payload?.feedback_id ?? payload?.feedbackId ?? null,
	sourceReferenceId: payload?.source_reference_id ?? payload?.sourceReferenceId ?? null,
	sourcePlatform: payload?.source_platform ?? payload?.sourcePlatform ?? null,
	channelId: payload?.channel_id ?? payload?.channelId ?? null,
	channelName: payload?.channel_name ?? payload?.channelName ?? null,
	feedbackDate: payload?.feedback_date ?? payload?.feedbackDate ?? null,
	feedbackDateDisplay: payload?.feedback_date_display ?? payload?.feedbackDateDisplay ?? null,
	customerName: payload?.customer_name ?? payload?.customerName ?? null,
	summary: payload?.summary ?? null,
	body: payload?.body ?? null,
	productName: payload?.product_name ?? payload?.productName ?? null,
	categoryName: payload?.category_name ?? payload?.categoryName ?? null,
	sentimentCategory: payload?.sentiment_category ?? payload?.sentimentCategory ?? null,
	churnRisk: payload?.churn_risk ?? payload?.churnRisk ?? null,
	churnRiskScore10: payload?.churn_risk_score_10 ?? payload?.churnRiskScore10 ?? null,
	rootCause: payload?.root_cause ?? payload?.rootCause ?? null,
});
